import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { SBPopularCategoriesAction } from "./sb-popular-categories.action";
import { SBPopularCategoriesState } from "./sb-popular-categories.model";

const INITIAL_STATE: SBPopularCategoriesState = {
	popularCategories: [],
	sbQuickLinks: [],
};

export const sbPopularCategoriesReducer = createReducer(
	INITIAL_STATE,
	on(SBPopularCategoriesAction.fetchAllSuccess, (state, { categories }) =>
		updateState(state, {
			popularCategories: categories.items,
		})
	),
	on(SBPopularCategoriesAction.transformToQuickLinksSuccess, (state, { quickLinksCategories }) =>
		updateState(state, {
			sbQuickLinks: quickLinksCategories,
		})
	)
);
